import script from "./VVVLayoutNew.vue?vue&type=script&setup=true&lang=js"
export * from "./VVVLayoutNew.vue?vue&type=script&setup=true&lang=js"

import "./VVVLayoutNew.vue?vue&type=style&index=0&id=227b8a1c&lang=css"
import "./VVVLayoutNew.vue?vue&type=style&index=1&id=227b8a1c&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\s\\CSD.SPA\\ClientApp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-227b8a1c"]])

export default __exports__